'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var styled = _interopDefault(require('styled-components'));
var PropTypes = _interopDefault(require('prop-types'));
var functions = require('@keytrade/functions');
var componentsVisuallyhidden = require('@keytrade/components-visuallyhidden');
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var focusVisible = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory();
  })(commonjsGlobal, function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };

      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */
      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
          return true;
        }
        return false;
      }

      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */
      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }
        if (tagName === 'TEXTAREA' && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }

      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */
      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }
        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }

      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }
        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }

      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */
      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }

      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */
      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }

      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */
      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }

      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */
      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }

      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */
      function onVisibilityChange(e) {
        if (document.visibilityState === 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }

      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */
      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }

      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */
      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }

      // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:
      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
      addInitialPointerMoveListeners();

      // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:
      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true);

      // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
        document.documentElement.setAttribute('data-js-focus-visible', '');
      }
    }

    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

      // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:
      var event;
      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }
  });
});

/* istanbul ignore file */
// See https://github.com/styled-components/babel-plugin-styled-components/issues/216
// @CSS_IMPORT_FIX const css = require('styled-components').css

var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var ButtonBase = function ButtonBase(props) {
  return props.href ? /*#__PURE__*/React__default.createElement(StyledLink, props) : /*#__PURE__*/React__default.createElement(StyledButton, props);
};
var StyledButton = styled.button.withConfig({
  displayName: "ButtonBase__StyledButton",
  componentId: "sc-dmj4j6-0"
})(["position:relative;", " align-items:center;border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";box-sizing:border-box;cursor:", ";display:inline-flex;font-family:", ";font-size:", "rem;justify-content:center;line-height:1;margin:0;min-width:", ";padding:0 ", ";position:relative;text-align:center;text-decoration:none;transition:all 0.2s ease;user-select:none;vertical-align:middle;width:", ";z-index:1;&:focus{outline:none;box-shadow:0 0 0 0.4rem ", ";}&.focus-visible:focus,&:focus-visible{border:2px solid black;}&:focus:not(.focus-visible){box-shadow:0 0 0.3rem 0 ", ";}height:", ";", ""], function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.append ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.prepend ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.prepend ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.append ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return getFont(props.theme, 'bold');
}, function (props) {
  return props.extraSmall ? '1.2' : props.small ? '1.4' : '1.6';
}, function (props) {
  if (props.fullWidth) return 'auto';
  if (props.buttonIcon && props.iconOnly) return '0';
  if (props.extraSmall) return '5rem';
  if (props.small || props.buttonIcon) return '10rem';
  return '14rem';
}, function (props) {
  if (props.iconOnly) return '0';
  if (props.extraSmall) return '1rem';
  if (props.small) return '1.2rem';
  return '1.2rem';
}, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, colors.BlueCloudyTransparent, colors.BlueCloudyTransparent, function (props) {
  return props.buttonIcon && props.iconOnly ? 'auto' : props.extraSmall ? '2.8rem' : props.small ? '3.4rem' : '4.4rem';
}, function (props) {
  return props.buttonIcon && "\n    svg {\n      margin: ".concat(props.reverse ? "0 0 0 ".concat(props.iconSpace) : "0 ".concat(props.iconSpace, " 0 0"), ";\n      order: ").concat(props.reverse ? '1' : '0', ";\n    }\n    path {\n      fill: ").concat(colors[props.iconColor], ";\n    }\n    &:hover, &:focus {\n      path {\n        fill: ").concat(colors[props.iconColorHover], ";\n      }\n    }\n    \n  ");
});
var StyledLink = styled.a.withConfig({
  displayName: "ButtonBase__StyledLink",
  componentId: "sc-dmj4j6-1"
})(["position:relative;", " align-items:center;border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";box-sizing:border-box;cursor:", ";display:inline-flex;font-family:", ";font-size:", "rem;justify-content:center;line-height:1;margin:0;min-width:", ";padding:0 ", ";position:relative;text-align:center;text-decoration:none;transition:all 0.2s ease;user-select:none;vertical-align:middle;width:", ";z-index:1;&:focus{outline:none;box-shadow:0 0 0 0.4rem ", ";}&:focus:not(.focus-visible){box-shadow:0 0 0.3rem 0 ", ";}height:", ";", ""], function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.append ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.prepend ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.prepend ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.append ? '0' : props.extraSmall || props.small ? '.3rem' : '.5rem';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return getFont(props.theme, 'bold');
}, function (props) {
  return props.extraSmall ? '1.2' : props.small ? '1.4' : '1.6';
}, function (props) {
  if (props.fullWidth) return 'auto';
  if (props.buttonIcon && props.iconOnly) return '0';
  if (props.extraSmall) return '5rem';
  if (props.small || props.buttonIcon) return '10rem';
  return '14rem';
}, function (props) {
  if (props.iconOnly) return '0';
  if (props.extraSmall) return '1rem';
  if (props.small) return '1.2rem';
  return '1.2rem';
}, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, colors.BlueCloudyTransparent, colors.BlueCloudyTransparent, function (props) {
  return props.buttonIcon && props.iconOnly ? 'auto' : props.extraSmall ? '2.8rem' : props.small ? '3.4rem' : '4.4rem';
}, function (props) {
  return props.buttonIcon && "\n    svg {\n      margin: ".concat(props.reverse ? "0 0 0 ".concat(props.iconSpace) : "0 ".concat(props.iconSpace, " 0 0"), ";\n      order: ").concat(props.reverse ? '1' : '0', ";\n    }\n    path {\n      fill: ").concat(colors[props.iconColor], ";\n    }\n    &:hover, &:focus {\n      path {\n        fill: ").concat(colors[props.iconColorHover], ";\n      }\n    }\n    \n  ");
});
ButtonBase.propTypes = {
  /** Disable the button and use a disabled style */
  disabled: PropTypes.bool,
  /** Make the button take 100% width */
  fullWidth: PropTypes.bool,
  /** If provided, will render and behave like an anchor tag, but styled as a button */
  href: PropTypes.string,
  /** Add a primary style to the button */
  primary: PropTypes.bool,
  /** Make the button smaller */
  small: PropTypes.bool,
  /** Make the button smallest */
  extraSmall: PropTypes.bool,
  /** Make the button smallest */
  buttonIcon: PropTypes.bool,
  /** if the button has no children, only an icon */
  iconOnly: PropTypes.bool,
  /** Used for the bold font (use a ThemeProvider theme to activate) */
  theme: PropTypes.object,
  /** Use when the button is displayed to the left, grouped with another input element.  */
  prepend: PropTypes.bool,
  /** Use when the button is displayed to the right, grouped with another input element.  */
  append: PropTypes.bool
};
ButtonBase.defaultProps = {
  disabled: false,
  fullWidth: false,
  primary: false,
  small: false,
  extraSmall: false,
  theme: undefined
};
var colors$1 = functions.config.colors.list;
var DEFAULT_STYLE = "\n  background-color: ".concat(colors$1.GreyMedium, ";\n  border: 0.2rem solid ").concat(colors$1.GreyMedium, ";\n  color: ").concat(colors$1.White, ";\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.GreyWarm, ";\n    border: 0.2rem solid ").concat(colors$1.GreyWarm, ";\n  }\n");
var DISABLED_STYLE = "\n   &:focus {\n    box-shadow: none !important;\n   }\n  &, &:hover, &:focus {\n    color: ".concat(colors$1.GreyMedium, ";\n    cursor: not-allowed;\n    background-color: ").concat(colors$1.GreyLight, ";\n    border: 0.2rem solid ").concat(colors$1.GreyLight, ";\n  }\n");
var PRIMARY_STYLE = "\n  background-color: ".concat(colors$1.BlueSky, ";\n  border: 0.2rem solid ").concat(colors$1.BlueSky, ";\n  color: ").concat(colors$1.White, ";\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.BlueDawn, ";\n    border: 0.2rem solid ").concat(colors$1.BlueDawn, ";\n  }\n");
var PRIMARY_DARK_STYLE = "\n  ".concat(PRIMARY_STYLE, "\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.BlueHeaven, ";\n    border: 0.2rem solid ").concat(colors$1.BlueHeaven, ";\n  }\n");
var SECONDARY_STYLE = "\n  border-width: 0.2rem;\n  background-color: ".concat(colors$1.Transparent, ";\n  border: 0.2rem solid ").concat(colors$1.BlueSky, ";\n  color: ").concat(colors$1.BlueSky, ";\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.Transparent, ";\n    border: 0.2rem solid ").concat(colors$1.BlueDawn, ";\n    color: ").concat(colors$1.BlueDawn, ";\n  }\n");
var SECONDARY_DARK_STYLE = "\n  ".concat(SECONDARY_STYLE, "\n  &:hover, &:focus {\n    border: 0.2rem solid ").concat(colors$1.BlueHeaven, ";\n    color: ").concat(colors$1.BlueHeaven, ";\n  }\n");
var GHOST_STYLE = "\n  border-width: 0.2rem;\n  background-color: ".concat(colors$1.Transparent, ";\n  border: 0.2rem solid ").concat(colors$1.White, ";\n  color: ").concat(colors$1.White, ";\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.BlackTransparentLight, ";\n    border: 0.2rem solid ").concat(colors$1.White, ";\n  }\n");
var ACQUISITION_STYLE = "\n  background-color: ".concat(colors$1.GreenSeafoam, ";\n  border: 0.2rem solid ").concat(colors$1.GreenSeafoam, ";\n  color: ").concat(colors$1.White, ";\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.GreenDark, ";\n    border: 0.2rem solid ").concat(colors$1.GreenDark, ";\n  }\n");
var ACQUISITION_DARK_STYLE = "\n  ".concat(ACQUISITION_STYLE, "\n  &:hover, &:focus {\n    border: 0.2rem solid ").concat(colors$1.GreenLight, ";\n    background-color: ").concat(colors$1.GreenLight, ";\n  }\n");
var LOW_ACTION_STYLE = "\n  background-color: ".concat(colors$1.Tomato, ";\n  border: 0.2rem solid ").concat(colors$1.Tomato, ";\n  color: ").concat(colors$1.White, ";\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.TomatoDark, ";\n    border: 0.2rem solid ").concat(colors$1.TomatoDark, ";\n  }\n");
var LOW_ACTION_DARK_STYLE = "\n  ".concat(LOW_ACTION_STYLE, "\n  &:hover, &:focus {\n    background-color: ").concat(colors$1.TomatoFlash, ";\n    border: 0.2rem solid ").concat(colors$1.TomatoFlash, ";\n  }\n");
var DefaultButton = styled(ButtonBase).withConfig({
  displayName: "LegacyButton__DefaultButton",
  componentId: "sc-18f9p9p-0"
})(["", ""], DEFAULT_STYLE);
var DisabledButton = styled(DefaultButton).withConfig({
  displayName: "LegacyButton__DisabledButton",
  componentId: "sc-18f9p9p-1"
})(["", ""], DISABLED_STYLE);
var PrimaryButton = styled(DefaultButton).withConfig({
  displayName: "LegacyButton__PrimaryButton",
  componentId: "sc-18f9p9p-2"
})(["", ""], function (props) {
  return props.theme.dark ? PRIMARY_DARK_STYLE : PRIMARY_STYLE;
});
var SecondaryButton = styled(DefaultButton).withConfig({
  displayName: "LegacyButton__SecondaryButton",
  componentId: "sc-18f9p9p-3"
})(["", ""], function (props) {
  return props.theme.dark ? SECONDARY_DARK_STYLE : SECONDARY_STYLE;
});
var GhostButton = styled(DefaultButton).withConfig({
  displayName: "LegacyButton__GhostButton",
  componentId: "sc-18f9p9p-4"
})(["", ""], GHOST_STYLE);
var AcquisitionButton = styled(DefaultButton).withConfig({
  displayName: "LegacyButton__AcquisitionButton",
  componentId: "sc-18f9p9p-5"
})(["", ""], function (props) {
  return props.theme.dark ? ACQUISITION_DARK_STYLE : ACQUISITION_STYLE;
});
var LowActionButton = styled(DefaultButton).withConfig({
  displayName: "LegacyButton__LowActionButton",
  componentId: "sc-18f9p9p-6"
})(["", ""], function (props) {
  return props.theme.dark ? LOW_ACTION_DARK_STYLE : LOW_ACTION_STYLE;
});
var LegacyButton = /*#__PURE__*/function (_Component) {
  function LegacyButton() {
    var _this;
    _classCallCheck(this, LegacyButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LegacyButton, [].concat(args));
    _defineProperty(_this, "disableClick", function (event) {
      event.preventDefault();
    });
    return _this;
  }
  _inherits(LegacyButton, _Component);
  return _createClass(LegacyButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        primary = _this$props.primary,
        secondary = _this$props.secondary,
        ghost = _this$props.ghost,
        acquisition = _this$props.acquisition,
        lowAction = _this$props.lowAction,
        onClick = _this$props.onClick;
      var ButtonToRender = DefaultButton;
      if (disabled) {
        ButtonToRender = DisabledButton;
      } else if (primary) {
        ButtonToRender = PrimaryButton;
      } else if (secondary) {
        ButtonToRender = SecondaryButton;
      } else if (ghost) {
        ButtonToRender = GhostButton;
      } else if (acquisition) {
        ButtonToRender = AcquisitionButton;
      } else if (lowAction) {
        ButtonToRender = LowActionButton;
      }
      return /*#__PURE__*/React__default.createElement(ButtonToRender, _extends({}, this.props, {
        onClick: disabled ? this.disableClick : onClick
      }), children);
    }
  }]);
}(React.Component);
LegacyButton.propTypes = {
  /** Add an acquisition style to the button, used to get people to subscribe or sign-up */
  acquisition: PropTypes.bool,
  /** Disable the button and use a disabled style */
  disabled: PropTypes.bool,
  /** Smallest size for the button */
  extraSmall: PropTypes.bool,
  /** Make the button take 100% width */
  fullWidth: PropTypes.bool,
  /** Transparent background style, mostly used with a ThemeProvider */
  ghost: PropTypes.bool,
  /** If provided, will render and behave like an anchor tag, but styled as a button */
  href: PropTypes.string,
  /**  Add an lowAction style to the button */
  lowAction: PropTypes.bool,
  /**  Add a primary style to the button */
  primary: PropTypes.bool,
  /**  Add a secondary style to the button, should be accompanied by a primary button */
  secondary: PropTypes.bool,
  /**  Make the button smaller */
  small: PropTypes.bool,
  /**  Adapt styles in theme {dark: true} (use a ThemeProvider theme to activate) */
  theme: PropTypes.object,
  /** Use when the button is displayed to the left, grouped with another input element.  */
  prepend: PropTypes.bool,
  /** Use when the button is displayed to the right, grouped with another input element.  */
  append: PropTypes.bool
};
LegacyButton.defaultProps = {
  acquisition: false,
  disabled: false,
  extraSmall: false,
  fullWidth: false,
  ghost: false,
  lowAction: false,
  primary: false,
  secondary: false,
  small: false,
  theme: undefined
};
var colors$2 = functions.config.colors.list;
var ButtonIcon = /*#__PURE__*/function (_React$Component) {
  function ButtonIcon() {
    _classCallCheck(this, ButtonIcon);
    return _callSuper(this, ButtonIcon, arguments);
  }
  _inherits(ButtonIcon, _React$Component);
  return _createClass(ButtonIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        icon = _this$props.icon,
        children = _this$props.children,
        reverse = _this$props.reverse,
        iconColor = _this$props.iconColor,
        iconColorHover = _this$props.iconColorHover;
      return /*#__PURE__*/React__default.createElement(LegacyButton, _extends({
        buttonIcon: true,
        onMouseEnter: this.onFocusHandler,
        onMouseLeave: this.onFocusOutHandler,
        iconOnly: !children,
        iconColor: iconColor,
        iconColorHover: iconColorHover
      }, this.props), !reverse && icon, children, reverse && icon);
    }
  }]);
}(React__default.Component);
var colorKeys = Object.keys(colors$2);
ButtonIcon.propTypes = _objectSpread2(_objectSpread2({}, LegacyButton.propTypes), {}, {
  /** Icon name */
  icon: PropTypes.element.isRequired,
  /** Icon color, if not set will take the icon default color */
  iconColor: PropTypes.oneOf([].concat(colorKeys, _toConsumableArray(colorKeys.map(function (key) {
    return colors$2[key];
  })))),
  /** Icon hover color, if not set will take the color value by default */
  iconColorHover: PropTypes.oneOf([].concat(colorKeys, _toConsumableArray(colorKeys.map(function (key) {
    return colors$2[key];
  })))),
  /** Icon vertical spacing from the text, 0 by default (you need to put the REM unit in the string) */
  iconSpace: PropTypes.string,
  /** Default icon goes left. If you pass true the icon is aligned right. */
  reverse: PropTypes.bool
});
ButtonIcon.defaultProps = _objectSpread2(_objectSpread2({}, LegacyButton.defaultProps), {}, {
  iconColor: null,
  iconColorHover: null,
  iconSpace: '0',
  reverse: false
});

// See https://github.com/styled-components/babel-plugin-styled-components/issues/216
// @CSS_IMPORT_FIX const css = require('styled-components').css

var colors$3 = functions.config.colors.list;
var getThemeFromType = function getThemeFromType(kind) {
  switch (kind) {
    case 'primary':
      return {
        lightColor: colors$3.White,
        lightBackground: colors$3.BlueSky,
        lightHoverColor: colors$3.White,
        lightHoverBackground: colors$3.BlueDawn,
        lightActiveColor: colors$3.White,
        lightActiveBackground: colors$3.BlueMoon
      };
    case 'secondary':
      return {
        lightColor: colors$3.BlueSky,
        lightBackground: 'transparent',
        lightHoverColor: colors$3.BlueNight,
        lightHoverBackground: 'transparent',
        lightActiveColor: colors$3.BlueDawn,
        lightActiveBackground: 'transparent'
      };
    case 'tertiary':
      return {
        lightColor: colors$3.GreyBlue,
        lightBackground: colors$3.GreyBackground,
        lightHoverColor: colors$3.BlueMoon,
        lightHoverBackground: colors$3.BlueCloudy,
        lightActiveColor: colors$3.BlueDark,
        lightActiveBackground: colors$3.BlueCloudy
      };
    case 'tertiaryNoBg':
      return {
        lightColor: colors$3.GreyBlue,
        lightBackground: 'transparent',
        lightHoverColor: colors$3.BlueMoon,
        lightHoverBackground: 'transparent',
        lightActiveColor: colors$3.BlueDark,
        lightActiveBackground: 'transparent'
      };
  }
};
var calcIconSize = function calcIconSize(size) {
  switch (size) {
    case 'sm':
      return '2.2rem';
    case 'md':
      return '2.8rem';
    case 'lg':
      return '3.4rem';
  }
};
var IconButton = function IconButton(props) {
  var StyledButton = styled.button.withConfig({
    displayName: "IconButton__StyledButton",
    componentId: "sc-5jqdco-0"
  })(["margin:", ";display:inline-flex;padding:", ";background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";border:none;cursor:", ";text-decoration:none;transition:all 0.2s ease-in-out;svg{width:", " !important;height:", " !important;}path,rect{fill:", ";transition:all 0.2s ease-in-out;}", " &:focus{outline:none;}&.focus-visible:focus{border:2px solid black;}"], function (props) {
    return props.margin;
  }, function (props) {
    switch (props.size) {
      case 'sm':
      case 'md':
        return '.3rem';
      case 'lg':
        return '.5rem';
    }
  }, function (props) {
    if (props.disabled) return colors$3.GreyLight;else return getThemeFromType(props.kind).lightBackground;
  }, function (props) {
    return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.disabled ? 'not-allowed' : 'pointer';
  }, function (props) {
    return calcIconSize(props.size);
  }, function (props) {
    return calcIconSize(props.size);
  }, function (props) {
    if (props.disabled) return colors$3.GreyMedium;else return getThemeFromType(props.kind).lightColor;
  }, function (props) {
    return !props.disabled && "\n        &:hover {\n            background-color: ".concat(getThemeFromType(props.kind).lightHoverBackground, ";\n\n            path, rect {\n                fill: ").concat(getThemeFromType(props.kind).lightHoverColor, ";\n            }\n        }\n\n        &:active {\n            background-color: ").concat(getThemeFromType(props.kind).lightActiveBackground, ";\n            transition: all 0s;\n\n            path, rect {\n                fill: ").concat(getThemeFromType(props.kind).lightActiveColor, ";\n            }\n        }\n    ");
  });
  var StyledLink = styled.a.withConfig({
    displayName: "IconButton__StyledLink",
    componentId: "sc-5jqdco-1"
  })(["margin:", ";display:inline-flex;padding:", ";background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";border:none;cursor:", ";text-decoration:none;transition:all 0.2s ease-in-out;svg{width:", " !important;height:", " !important;}path,rect{fill:", ";transition:all 0.2s ease-in-out;}", " &:focus{outline:none;}&.focus-visible:focus{border:2px solid black;}"], function (props) {
    return props.margin;
  }, function (props) {
    switch (props.size) {
      case 'sm':
      case 'md':
        return '.3rem';
      case 'lg':
        return '.5rem';
    }
  }, function (props) {
    if (props.disabled) return colors$3.GreyLight;else return getThemeFromType(props.kind).lightBackground;
  }, function (props) {
    return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
  }, function (props) {
    return props.disabled ? 'not-allowed' : 'pointer';
  }, function (props) {
    return calcIconSize(props.size);
  }, function (props) {
    return calcIconSize(props.size);
  }, function (props) {
    if (props.disabled) return colors$3.GreyMedium;else return getThemeFromType(props.kind).lightColor;
  }, function (props) {
    return !props.disabled && "\n        &:hover {\n            background-color: ".concat(getThemeFromType(props.kind).lightHoverBackground, ";\n\n            path, rect {\n                fill: ").concat(getThemeFromType(props.kind).lightHoverColor, ";\n            }\n        }\n\n        &:active {\n            background-color: ").concat(getThemeFromType(props.kind).lightActiveBackground, ";\n            transition: all 0s;\n\n            path, rect {\n                fill: ").concat(getThemeFromType(props.kind).lightActiveColor, ";\n            }\n        }\n    ");
  });
  return props.href ? /*#__PURE__*/React__default.createElement(StyledLink, props, props.icon, /*#__PURE__*/React__default.createElement(componentsVisuallyhidden.VisuallyHidden, null, props.accessibilityText)) : /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, props, {
    type: props.noSubmit && 'button'
  }), props.icon, /*#__PURE__*/React__default.createElement(componentsVisuallyhidden.VisuallyHidden, null, props.accessibilityText));
};
IconButton.propTypes = {
  /** Choose from the icon list. This includes deprecated icons, make sure you check your console for any warnings. */
  icon: PropTypes.element.isRequired,
  /** This controls the main styles of the button */
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'tertiaryNoBg']),
  /** This controls the size of the button */
  size: PropTypes.oneOf(['lg', 'md', 'sm']),
  onClick: PropTypes.func,
  /** If an href is passed, the component will render as a <a> instead of a <button> */
  href: PropTypes.string,
  /** Disabled styles (prevents triggering the onClick) */
  disabled: PropTypes.bool,
  /** Use this prop if you want to append the button to the right of an input */
  append: PropTypes.bool,
  /** Use this prop if you want to prepend the button to the left of an input */
  prepend: PropTypes.bool,
  /** hidden accessibility text, required */
  accessibilityText: PropTypes.string.isRequired,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** Set this prop to true if you do not want the default behaviour of a button submitting the <form> that it is in when pressed */
  noSubmit: PropTypes.bool
};
IconButton.defaultProps = {
  size: 'md',
  kind: 'primary'
};
var SpinnerIcon = function (props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    id: "loader"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(8.384615, 0.000000)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(12.333087, 2.996155) rotate(30.000000) translate(-12.333087, -2.996155) translate(11.333087, 0.996155)",
    fillOpacity: "0.9"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(14.395607, 5.331993) rotate(60.000000) translate(-14.395607, -5.331993) translate(13.395607, 3.331993)",
    fillOpacity: "0.84"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "-0.00262640682",
    y: "0.00673589553",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(15.000000, 8.384615) rotate(90.000000) translate(-15.000000, -8.384615) translate(14.000000, 6.384615)",
    fillOpacity: "0.76"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(14.003845, 11.333087) rotate(120.000000) translate(-14.003845, -11.333087) translate(13.003845, 9.333087)",
    fillOpacity: "0.68"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(11.666913, 13.388460) rotate(150.000000) translate(-11.666913, -13.388460) translate(10.666913, 11.388460)",
    fillOpacity: "0.6"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(8.615385, 14.000000) rotate(180.000000) translate(-8.615385, -14.000000) translate(7.615385, 12.000000)",
    fillOpacity: "0.52"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(5.666913, 13.003845) rotate(-150.000000) translate(-5.666913, -13.003845) translate(4.666913, 11.003845)",
    fillOpacity: "0.44"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(3.611540, 10.666913) rotate(-120.000000) translate(-3.611540, -10.666913) translate(2.611540, 8.666913)",
    fillOpacity: "0.36"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(3.000000, 7.615385) rotate(-90.000000) translate(-3.000000, -7.615385) translate(2.000000, 5.615385)",
    fillOpacity: "0.28"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(3.314474, 4.843698) rotate(-60.000000) translate(-3.314474, -4.843698) translate(1.814474, 2.343698)",
    fillOpacity: "0.2"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0.993941209",
    y: "1.00196102",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(6.333087, 2.611540) rotate(-30.000000) translate(-6.333087, -2.611540) translate(5.333087, 0.611540)",
    fillOpacity: "0.12"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: "1.23076923",
    height: "3.69230769",
    rx: "0.615384615"
  }))))));
};

// See https://github.com/styled-components/babel-plugin-styled-components/issues/216
// @CSS_IMPORT_FIX const css = require('styled-components').css

var colors$4 = functions.config.colors.list;
var getFont$1 = functions.config.fonts.getFont;
var getThemeFromType$1 = function getThemeFromType(kind) {
  switch (kind) {
    case 'primary':
      return {
        lightText: colors$4.White,
        darkText: colors$4.White,
        lightBackground: colors$4.BlueSky,
        darkBackground: colors$4.BlueSky,
        lightHoverText: colors$4.White,
        darkHoverText: colors$4.White,
        lightHoverBackground: colors$4.BlueDawn,
        darkHoverBackground: colors$4.BlueDawn,
        lightActiveText: colors$4.White,
        darkActiveText: colors$4.BlueDawn,
        lightActiveBackground: colors$4.BlueDark,
        darkActiveBackground: colors$4.White
      };
    case 'secondary':
      return {
        lightText: colors$4.BlueSky,
        darkText: colors$4.White,
        lightBackground: 'transparent',
        darkBackground: 'transparent',
        lightBorder: colors$4.BlueSky,
        darkBorder: colors$4.White,
        lightHoverText: colors$4.BlueNight,
        darkHoverText: colors$4.BlueLight,
        lightHoverBackground: 'transparent',
        darkHoverBackground: "rgba(255,255,255,0.1)",
        lightHoverBorder: colors$4.BlueNight,
        darkHoverBorder: colors$4.BlueLight,
        lightActiveText: colors$4.BlueDawn,
        darkActiveText: colors$4.GreyLight,
        lightActiveBackground: 'transparent',
        darkActiveBackground: "rgba(255,255,255,0.2)",
        lightActiveBorder: colors$4.BlueDawn,
        darkActiveBorder: colors$4.GreyLight
      };
    case 'red':
      return {
        lightText: colors$4.White,
        darkText: colors$4.White,
        lightBackground: colors$4.Tomato,
        darkBackground: colors$4.Tomato,
        lightHoverText: colors$4.White,
        darkHoverText: colors$4.White,
        lightHoverBackground: colors$4.TomatoDark,
        darkHoverBackground: colors$4.TomatoDark,
        lightActiveText: colors$4.White,
        darkActiveText: colors$4.White,
        lightActiveBackground: colors$4.TomatoFlash,
        darkActiveBackground: colors$4.TomatoFlash
      };
    case 'green':
      return {
        lightText: colors$4.White,
        darkText: colors$4.White,
        lightBackground: colors$4.GreenSeafoam,
        darkBackground: colors$4.GreenSeafoam,
        lightHoverText: colors$4.White,
        darkHoverText: colors$4.White,
        lightHoverBackground: colors$4.GreenDark,
        darkHoverBackground: colors$4.GreenDark,
        lightActiveText: colors$4.White,
        darkActiveText: colors$4.White,
        lightActiveBackground: colors$4.GreenGarden,
        darkActiveBackground: colors$4.GreenGarden
      };
  }
};
var IconLeftWrapper = styled.span.withConfig({
  displayName: "Button__IconLeftWrapper",
  componentId: "sc-177g7bu-0"
})(["display:inline-flex;margin-right:0.4rem;"]);
var IconRightWrapper = styled.span.withConfig({
  displayName: "Button__IconRightWrapper",
  componentId: "sc-177g7bu-1"
})(["display:inline-flex;margin-left:0.4rem;"]);
var StyledLoader = styled.div.withConfig({
  displayName: "Button__StyledLoader",
  componentId: "sc-177g7bu-2"
})(["display:flex;svg{animation:rotate 0.8s steps(12,end) infinite;}@keyframes rotate{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}"]);
var StyledButton$1 = styled.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-177g7bu-3"
})(["margin:", ";position:relative;", " width:", ";padding:", ";display:inline-flex;justify-content:center;align-items:center;border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";font-family:", ";font-size:", ";line-height:1.5;color:", ";background-color:", ";border:2px solid ", ";cursor:", ";text-decoration:none;transition:all 0.2s ease-in-out;", " &:focus{outline:none;}&.focus-visible:focus{border:2px solid black;}svg{height:", ";width:", ";}path,rect{fill:", ";transition:all 0.2s ease-in-out;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '.3rem .8rem';
    case 'md':
      return '.4rem 1rem .5rem';
    case 'lg':
      return '.8rem 1.2rem';
  }
}, function (props) {
  return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return getFont$1(props.theme, 'bold');
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.2rem';
    case 'md':
      return '1.4rem';
    case 'lg':
      return '1.6rem';
  }
}, function (props) {
  if (props.disabled) return colors$4.GreyMedium;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText;else return props.theme.dark ? getThemeFromType$1(props.kind).darkText : getThemeFromType$1(props.kind).lightText;
}, function (props) {
  if (props.disabled) return colors$4.GreyLight;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBackground;else return props.theme.dark ? getThemeFromType$1(props.kind).darkBackground : getThemeFromType$1(props.kind).lightBackground;
}, function (props) {
  if (props.disabled) return colors$4.GreyLight;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBorder || getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBorder || getThemeFromType$1(props.kind).lightActiveBackground;else return props.theme.dark ? getThemeFromType$1(props.kind).darkBorder || getThemeFromType$1(props.kind).darkBackground : getThemeFromType$1(props.kind).lightBorder || getThemeFromType$1(props.kind).lightBackground;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return !props.disabled && !props.isLoading && "\n    &:hover {\n      color: ".concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverText : getThemeFromType$1(props.kind).lightHoverText, ";\n      background-color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverBackground : getThemeFromType$1(props.kind).lightHoverBackground, ";\n      border: 2px solid ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverBorder || getThemeFromType$1(props.kind).darkHoverBackground : getThemeFromType$1(props.kind).lightHoverBorder || getThemeFromType$1(props.kind).lightHoverBackground, ";\n\n      path, rect {\n        fill: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverText : getThemeFromType$1(props.kind).lightHoverText, ";\n      }\n    }\n\n    &:active {\n      color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText, ";\n      background-color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBackground, ";\n      border: 2px solid ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBorder || getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBorder || getThemeFromType$1(props.kind).lightActiveBackground, ";\n      transition: all 0s;\n\n      path, rect {\n        fill: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText, ";\n      }\n    }\n  ");
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.8rem !important';
    case 'md':
      return '2.1rem';
    case 'lg':
      return '2.4rem !important';
  }
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.8rem !important';
    case 'md':
      return '2.1rem !important';
    case 'lg':
      return '2.4rem !important';
  }
}, function (props) {
  if (props.disabled) return colors$4.GreyMedium;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText;else return props.theme.dark ? getThemeFromType$1(props.kind).darkText : getThemeFromType$1(props.kind).lightText;
});
var StyledLink$1 = styled.a.withConfig({
  displayName: "Button__StyledLink",
  componentId: "sc-177g7bu-4"
})(["margin:", ";position:relative;", " width:", ";padding:", ";display:inline-flex;justify-content:center;align-items:center;border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";font-family:", ";font-size:", ";line-height:1.5;color:", ";background-color:", ";border:2px solid ", ";cursor:", ";text-decoration:none;transition:all 0.2s ease-in-out;", " &:focus{outline:none;}&.focus-visible:focus{border:2px solid black;}svg{height:", ";width:", ";}path,rect{fill:", ";transition:all 0.2s ease-in-out;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '.3rem .8rem';
    case 'md':
      return '.4rem 1rem .5rem';
    case 'lg':
      return '.8rem 1.2rem';
  }
}, function (props) {
  return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return getFont$1(props.theme, 'bold');
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.2rem';
    case 'md':
      return '1.4rem';
    case 'lg':
      return '1.6rem';
  }
}, function (props) {
  if (props.disabled) return colors$4.GreyMedium;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText;else return props.theme.dark ? getThemeFromType$1(props.kind).darkText : getThemeFromType$1(props.kind).lightText;
}, function (props) {
  if (props.disabled) return colors$4.GreyLight;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBackground;else return props.theme.dark ? getThemeFromType$1(props.kind).darkBackground : getThemeFromType$1(props.kind).lightBackground;
}, function (props) {
  if (props.disabled) return colors$4.GreyLight;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBorder || getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBorder || getThemeFromType$1(props.kind).lightActiveBackground;else return props.theme.dark ? getThemeFromType$1(props.kind).darkBorder || getThemeFromType$1(props.kind).darkBackground : getThemeFromType$1(props.kind).lightBorder || getThemeFromType$1(props.kind).lightBackground;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return !props.disabled && !props.isLoading && "\n    &:hover {\n      color: ".concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverText : getThemeFromType$1(props.kind).lightHoverText, ";\n      background-color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverBackground : getThemeFromType$1(props.kind).lightHoverBackground, ";\n      border: 2px solid ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverBorder || getThemeFromType$1(props.kind).darkHoverBackground : getThemeFromType$1(props.kind).lightHoverBorder || getThemeFromType$1(props.kind).lightHoverBackground, ";\n\n      path, rect {\n        fill: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverText : getThemeFromType$1(props.kind).lightHoverText, ";\n      }\n    }\n\n    &:active {\n      color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText, ";\n      background-color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBackground, ";\n      border: 2px solid ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBorder || getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBorder || getThemeFromType$1(props.kind).lightActiveBackground, ";\n      transition: all 0s;\n\n      path, rect {\n        fill: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText, ";\n      }\n    }\n  ");
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.8rem !important';
    case 'md':
      return '2.1rem';
    case 'lg':
      return '2.4rem !important';
  }
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.8rem !important';
    case 'md':
      return '2.1rem !important';
    case 'lg':
      return '2.4rem !important';
  }
}, function (props) {
  if (props.disabled) return colors$4.GreyMedium;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText;else return props.theme.dark ? getThemeFromType$1(props.kind).darkText : getThemeFromType$1(props.kind).lightText;
});
var RenderWrapper = styled.span.withConfig({
  displayName: "Button__RenderWrapper",
  componentId: "sc-177g7bu-5"
})(["a,button{margin:", ";position:relative;", " width:", ";padding:", ";display:inline-flex;justify-content:center;align-items:center;border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";font-family:", ";font-size:", ";line-height:1.5;color:", ";background-color:", ";border:2px solid ", ";cursor:", ";text-decoration:none;transition:all 0.2s ease-in-out;", " &:focus{outline:none;}&.focus-visible:focus{border:2px solid black;}svg{height:", ";width:", ";}path,rect{fill:", ";transition:all 0.2s ease-in-out;}}"], function (props) {
  return props.margin;
}, function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '.3rem .8rem';
    case 'md':
      return '.4rem 1rem .5rem';
    case 'lg':
      return '.8rem 1.2rem';
  }
}, function (props) {
  return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return props.append ? '0' : props.size === 'lg' ? '.5rem' : '.3rem';
}, function (props) {
  return getFont$1(props.theme, 'bold');
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.2rem';
    case 'md':
      return '1.4rem';
    case 'lg':
      return '1.6rem';
  }
}, function (props) {
  if (props.disabled) return colors$4.GreyMedium;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText;else return props.theme.dark ? getThemeFromType$1(props.kind).darkText : getThemeFromType$1(props.kind).lightText;
}, function (props) {
  if (props.disabled) return colors$4.GreyLight;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBackground;else return props.theme.dark ? getThemeFromType$1(props.kind).darkBackground : getThemeFromType$1(props.kind).lightBackground;
}, function (props) {
  if (props.disabled) return colors$4.GreyLight;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBorder || getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBorder || getThemeFromType$1(props.kind).lightActiveBackground;else return props.theme.dark ? getThemeFromType$1(props.kind).darkBorder || getThemeFromType$1(props.kind).darkBackground : getThemeFromType$1(props.kind).lightBorder || getThemeFromType$1(props.kind).lightBackground;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return !props.disabled && !props.isLoading && "\n    &:hover {\n      color: ".concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverText : getThemeFromType$1(props.kind).lightHoverText, ";\n      background-color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverBackground : getThemeFromType$1(props.kind).lightHoverBackground, ";\n      border: 2px solid ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverBorder || getThemeFromType$1(props.kind).darkHoverBackground : getThemeFromType$1(props.kind).lightHoverBorder || getThemeFromType$1(props.kind).lightHoverBackground, ";\n\n      path, rect {\n        fill: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkHoverText : getThemeFromType$1(props.kind).lightHoverText, ";\n      }\n    }\n\n    &:active {\n      color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText, ";\n      background-color: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBackground, ";\n      border: 2px solid ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveBorder || getThemeFromType$1(props.kind).darkActiveBackground : getThemeFromType$1(props.kind).lightActiveBorder || getThemeFromType$1(props.kind).lightActiveBackground, ";\n      transition: all 0s;\n\n      path, rect {\n        fill: ").concat(props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText, ";\n      }\n    }\n  ");
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.8rem !important';
    case 'md':
      return '2.1rem';
    case 'lg':
      return '2.4rem !important';
  }
}, function (props) {
  switch (props.size) {
    case 'sm':
      return '1.8rem !important';
    case 'md':
      return '2.1rem !important';
    case 'lg':
      return '2.4rem !important';
  }
}, function (props) {
  if (props.disabled) return colors$4.GreyMedium;else if (props.isLoading) return props.theme.dark ? getThemeFromType$1(props.kind).darkActiveText : getThemeFromType$1(props.kind).lightActiveText;else return props.theme.dark ? getThemeFromType$1(props.kind).darkText : getThemeFromType$1(props.kind).lightText;
});
var RenderedElement = function RenderedElement(props) {
  return props.render ? /*#__PURE__*/React__default.createElement(RenderWrapper, props, props.render()) : props.href ? /*#__PURE__*/React__default.createElement(StyledLink$1, _extends({
    target: props.href && props.targetBlank ? '_blank' : null,
    rel: props.targetBlank ? 'noopener noreferrer' : 'noreferrer'
  }, props)) : /*#__PURE__*/React__default.createElement(StyledButton$1, _extends({}, props, {
    type: props.noSubmit && 'button'
  }));
};
var Button = function Button(props) {
  return /*#__PURE__*/React__default.createElement(RenderedElement, props, props.isLoading ? /*#__PURE__*/React__default.createElement(IconLeftWrapper, {
    size: props.size
  }, /*#__PURE__*/React__default.createElement(StyledLoader, null, /*#__PURE__*/React__default.createElement(SpinnerIcon, null))) : props.iconLeft && /*#__PURE__*/React__default.createElement(IconLeftWrapper, {
    size: props.size
  }, props.iconLeft), props.children, !props.isLoading && props.iconRight && /*#__PURE__*/React__default.createElement(IconRightWrapper, {
    size: props.size
  }, props.iconRight));
};
Button.propTypes = {
  /** This controls the main styles of the button */
  kind: PropTypes.oneOf(['primary', 'secondary', 'red', 'green']),
  /** This controls the size of the button */
  size: PropTypes.oneOf(['lg', 'md', 'sm']),
  /** Force the button to take 100% of its container */
  fullWidth: PropTypes.bool,
  /** Display an icon on the left side */
  iconLeft: PropTypes.element,
  /** Display an icon on the right side */
  iconRight: PropTypes.element,
  /** Disabled styles (prevents triggering the onClick) */
  disabled: PropTypes.bool,
  /** Loading styles */
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  /** If an href is passed, the component will render as a <a> instead of a <button> */
  href: PropTypes.string,
  /** Use this prop if you want to append the button to the right of an input */
  append: PropTypes.bool,
  /** Use this prop if you want to prepend the button to the left of an input */
  prepend: PropTypes.bool,
  /** Set this prop to true if you do not want the default behaviour of a button submitting the <form> that it is in when pressed */
  noSubmit: PropTypes.bool,
  /** Render a custom component (useful if you are using Gatsby's Link component for routing for example) */
  render: PropTypes.func,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** when used in combination with an href, force opening the link in a new tab */
  targetBlank: PropTypes.bool
};
Button.defaultProps = {
  size: 'md',
  kind: 'primary'
};
exports.LegacyButton = LegacyButton;
exports.ButtonIcon = ButtonIcon;
exports.IconButton = IconButton;
exports.Button = Button;